package one.healthium.healthKit.ui

import ifaandroid.feature.healthkit.generated.resources.Res
import ifaandroid.feature.healthkit.generated.resources.ic_apple_health
import ifaandroid.feature.healthkit.generated.resources.icn_health_connect
import loco.HEALTH_KIT_APPLE_HEALTH_NAME
import loco.HEALTH_KIT_HEALTH_CONNECT_NAME
import loco.HEALTH_KIT_MANAGE_HINT_ANDROID_FORMAT
import loco.HEALTH_KIT_MANAGE_HINT_IOS_FORMAT
import one.healthium.loco.LString
import one.healthium.loco.asLString
import one.healthium.ui.compose.utils.TargetPlatform
import one.healthium.ui.compose.utils.targetPlatform
import org.jetbrains.compose.resources.DrawableResource

object ConnectBannerHelper {

    val healthKitIcon: DrawableResource = when (targetPlatform()) {
        TargetPlatform.Android -> Res.drawable.icn_health_connect
        TargetPlatform.IOS -> Res.drawable.ic_apple_health
        TargetPlatform.Web -> Res.drawable.ic_apple_health
    }

    val healthKitName: LString = when (targetPlatform()) {
        TargetPlatform.Android -> loco.Res.string.HEALTH_KIT_HEALTH_CONNECT_NAME.asLString()
        TargetPlatform.IOS -> loco.Res.string.HEALTH_KIT_APPLE_HEALTH_NAME.asLString()
        TargetPlatform.Web -> loco.Res.string.HEALTH_KIT_APPLE_HEALTH_NAME.asLString()
    }

    fun healthKitManageHint(appName: String): LString = when (targetPlatform()) {
        TargetPlatform.Android -> loco.Res.string.HEALTH_KIT_MANAGE_HINT_ANDROID_FORMAT.asLString(listOf(healthKitName, appName))
        TargetPlatform.IOS -> loco.Res.string.HEALTH_KIT_MANAGE_HINT_IOS_FORMAT.asLString(listOf(healthKitName, appName))
        TargetPlatform.Web -> "".asLString()
    }
}